export const NOTIFICATIONS_GRID_NAME = 'notifications';
export const NOTIFICATIONS_HUB_NAME = 'NotificationsHub';

export enum NOTIFICATION_TYPES {
  'EconomicProfileChanged' = 'EconomicProfileChanged',
  'AppropriatenessTestPassed' = 'AppropriatenessTestPassed',
  'Deposit' = 'Deposit',
  'DepositAttempt' = 'DepositAttempt',
  'WithdrawRequest' = 'WithdrawRequest',
  'WithdrawRequestAttempt' = 'WithdrawRequestAttempt',
  'NewLeadsForSales' = 'NewLeadsForSales',
  'CalendarEvent' = 'CalendarEvent',
  'NewLeadsForTeamManagers' = 'NewLeadsForTeamManagers',
  'ClosePnlToBalanceLimitExceeded' = 'ClosePnlToBalanceLimitExceeded',
  'CriticalEquityExceeded' = 'CriticalEquityExceeded',
  'CriticalOpenPnlSumExceeded' = 'CriticalOpenPnlSumExceeded',
  'DocumentUploaded' = 'DocumentUploaded',
  'LeadAction' = 'LeadAction',
  'ExpiringDeals' = 'ExpiringDeals',
  'ExpiringDealsForTeamManagers' = 'ExpiringDealsForTeamManagers',
  'NewLeadDuplicateByPhone' = 'NewLeadDuplicateByPhone',
  'UnprocessedWithdrawRequest' = 'UnprocessedWithdrawRequest',
  'ClientChangedPersonalData' = 'ClientChangedPersonalData',
  'IdentityDocumentExpires' = 'IdentityDocumentExpires',
  'TotalDepositLimitExceeded' = 'TotalDepositLimitExceeded',
  'NewLeadDepositCardUsed' = 'NewLeadDepositCardUsed',
  'NewDepositPaymentMethod' = 'NewDepositPaymentMethod',
  'VideoVerificationRequested' = 'VideoVerificationRequested',
  'DormantClient' = 'DormantClient',
  'DormantClientRestoreActive' = 'DormantClientRestoreActive',
  'RefillDemoAccountAttempt' = 'RefillDemoAccountAttempt',
}

export const NOTIFICATION_TYPE_ALL = 'All';
